import { render, staticRenderFns } from "./DashboardWidgetCatalog.vue?vue&type=template&id=e0c78a84&scoped=true"
import script from "./DashboardWidgetCatalog.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetCatalog.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetCatalog.vue?vue&type=style&index=0&id=e0c78a84&prod&lang=css"
import style1 from "./DashboardWidgetCatalog.vue?vue&type=style&index=1&id=e0c78a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c78a84",
  null
  
)

export default component.exports